import {Pipe, PipeTransform} from '@angular/core';
import {CategoryType} from "@model";

@Pipe({
    name: 'categoryType',
    standalone: false
})
export class CategoryTypePipe implements PipeTransform {

  transform(value?: CategoryType): string {
    if (!value) return 'Unknown';

    switch (value) {
      case CategoryType.STANDARD:
        return 'Standard';
      case CategoryType.CYCLING:
        return 'Cycling';
      default:
        return 'Unknown';
    }
  }
}
